import './popup.css';

import pdf_poste from '../../media/poste.png';

const Popup = ({ onClose }) => {
    return (
        <div className="popup" onClick={onClose}>
            <div className="popup-inner" onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose}>X</button>

                <img src={pdf_poste} alt="Poste à pourvoir" className="popup-image" />

                <a href="/postuler">Postuler</a>
            </div>
        </div>
    );
};

export default Popup;
